import { useSelector } from "react-redux";
import { RootState } from "./redux/store";
import Router from "./routes/Router";

const RouterWrapper = () => {
  const isInitialized = useSelector((state: RootState) => state.auth.isInitialized);

  if (!isInitialized) return null; // או Spinner

  return <Router />;
};

export default RouterWrapper;
